import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { DomSanitizer } from '@angular/platform-browser';
import { RouterOutlet } from '@angular/router';
import { GoogleTagManagerService } from '@psu-pennstateit-swe/utils/analytics';
import { CdnModule } from '@psu-pennstateit-swe/utils/cdn';
import { ResponsiveService } from '@psu-pennstateit-swe/utils/responsive';
import { Observable } from 'rxjs';
import packageJson from '../../package.json';
import { APP_CONFIG } from './app.model';
import { SidenavComponent } from './features/sidenav/sidenav.component';

@Component({
  selector: 'cca-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  imports: [AsyncPipe, CdnModule, MatSidenavModule, MatToolbarModule, RouterOutlet, SidenavComponent],
})
export class AppComponent {
  readonly appVersion = packageJson.version;
  readonly psuLink = 'https://www.psu.edu/';
  readonly environmentLabel: string;
  readonly psuHorizontalLogo = 'img/PSU_HOR_RGB_2C.svg';
  readonly isDesktop$: Observable<boolean>;
  private readonly appConfig = inject(APP_CONFIG);
  private readonly domSanitizer = inject(DomSanitizer);
  private readonly gtmService = inject(GoogleTagManagerService); // Required for Google Analytics
  private readonly matIconRegistry = inject(MatIconRegistry);
  private readonly responsiveService = inject(ResponsiveService);

  constructor() {
    this.matIconRegistry.addSvgIconSet(this.domSanitizer.bypassSecurityTrustResourceUrl('./images/mdi.svg'));

    this.environmentLabel = this.appConfig.environmentLabel || '';
    this.isDesktop$ = this.responsiveService.isDesktop$;
  }
}
